import { Component, ElementRef, ViewChild, OnInit, AfterViewInit } from '@angular/core';
import { Router} from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import '../../prism/prism.js'
import { LanguageSettings } from '../../providers/languageSettings.service';
declare var Prism;

@Component({
  selector: 'app-getstartededgemodule',
  templateUrl: './getstartededgemodule.html',
  styleUrls: ['../bleclassmodule/bleclassmodule.css']
})


export class GetStartedEdgeComponent implements OnInit, AfterViewInit {

  selected = 'Java';

  JavaServiceXMLPrism:string;
  SwiftServiceXMLPrism:string;
  JavaScriptServiceXMLPrism:string;
  JavaServiceXML:string = "\
\n<service \n\
   android:name='com.scientificgames.connect.ble.Internal.BLECardlessConnect.BLEBackgroundService'>\n\
</service>";


  SwiftOnResultPrism:string;
  JavaScriptOnResultPrism:string;
  JavaOnResultPrism:string;
  JavaOnResult:string =
"@Override\n\
public void onActivityResult(int requestCode, int resultCode, Intent data){\n\
    Log.d(\"TAG\", \"req: \" + requestCode + \" res: \" + resultCode);\n\
    \n\
    SGConnectBLE.onActivityResult(requestCode,resultCode,data);\n\
}\n\
\n\
@Override\n\
public void onRequestPermissionsResult(int requestCode,\n\
                                        String permissions[], int[] grantResults){\n\
    SGConnectBLE.onRequestPermissionsResult(requestCode,permissions,grantResults);\n\
}";


  SwiftCommandPrism:string;
  JavaCommandPrism:string;
  JavaScriptCommandPrism:string;
  JavaScriptCommand:string = "\n cordova plugin add cordova-plugin-sgconnectapiplugin \n";

  JavaScriptGradlePrism:string;
  SwiftGradlePrism:string;
  JavaGradlePrism:string;
  JavaScriptGradle:string = "\nrepositories {\n\
  \tgoogle()\n\
  \tjcenter()\n\
}\n\
";

  SwiftSourceCompatPrism:string;
  JavaScriptSourceCompatPrism:string;
  JavaSourceCompatPrism:string;
  JavaSourceCompat:string = "\n\
  compileOptions {\n\
  \tsourceCompatibility JavaVersion.VERSION_1_6\n\
  \ttargetCompatibility JavaVersion.VERSION_1_6\n\
  }\n\
  ";


  SwiftImplementationPrism:string;
  JavaScriptImplementationPrism:string;
  JavaImplementationPrism:string;
  JavaImplementation:string = "\n\
  implementation project(':sgconnectapi')\n\
  ";

  JavaDependenciesPrism: string;
  JavaScriptDependenciesPrism: string;
  SwiftDependenciesPrism: string;
  SwiftDependencies = '\n\
  <key>UIRequiredDeviceCapabilities</key>\n\
  <array>\n\
    <string>bluetooth-le</string>\n\
  </array>\n\
  <key>NSBluetoothPeripheralUsageDescription</key>\n\
  <string>Allow application to communicate with the gaming machine.</string>\n\
  <key>UIBackgroundModes</key>\n\
  <array>\n\
    <string>bluetooth-central</string>\n\
  </array>';

  JavaScriptiOSDependenciesPrism: string;
  JavaScriptiOSDependencies = '<preference name="deployment-target" value="10" />';

  JavaDependencies = "\n\
  dependencies{\n\
  \timplementation ('com.github.joshjdevl.libsodiumjni:libsodium-jni-aar:1.0.8'){\n\
      transitive = true;\n\
  \t}\n\
  \timplementation ('com.google.android.gms:play-services-vision:10.2.6'){\n\
      transitive = true;\n\
  \t}\n\
  \timplementation ('com.android.support.constraint:constraint-layout:1.0.2'){\n\
      transitive = true;\n\
  \t}\n\
  \timplementation ('org.java-websocket:Java-WebSocket:1.3.4'){\n\
      transitive = true;\n\
  \t}\n\
  \timplementation ('com.jaredrummler:android-device-names:1.1.7'){\n\
      transitive = true;\n\
  \t}\n\
  \timplementation ('com.google.android.gms:play-services-location:10.2.6'){\n\
      transitive = true;\n\
  \t}\n\
  \timplementation ('io.reactivex.rxjava2:rxandroid:2.0.1'){\n\
      transitive = true;\n\
  \t}\n\
  \timplementation ('io.reactivex.rxjava2:rxjava:2.1.5'){\n\
      transitive = true;\n\
  \t}\n\
  \timplementation ('com.jakewharton.rxbinding:rxbinding:0.4.0'){\n\
      transitive = true;\n\
  \t}\n\
  \timplementation ('com.jakewharton.rxbinding:rxbinding-appcompat-v7:0.4.0'){\n\
      transitive = true;\n\
 \t}\n\
  \timplementation ('com.google.code.gson:gson:2.8.2'){\n\
      transitive = true;\n\
  \t}\n\
}"

@ViewChild('walkthroughVideo') walkthroughVideo: ElementRef;

videoPlayer: HTMLVideoElement;

  constructor(
    public router: Router,
    public dialog: MatDialog,
    private languageSettings: LanguageSettings) {

  }


  onLanguageChanged(lang){
    console.log("onlanguagechanged: " + lang);
    this.selected = lang;
    if (this.videoPlayer) {
      this.videoPlayer.load();
    }
  }

  ngOnInit() {
    this.selected = this.languageSettings.getSelectedLanguage();
    this.languageSettings.getLanguageChangeEmitter().subscribe(
      item => this.onLanguageChanged(item)
    );
    this.applyPrism();
  }

  ngAfterViewInit() {
    this.applyPrism();
    this.videoPlayer = <HTMLVideoElement>this.walkthroughVideo.nativeElement;
  }

  onSkip() {
    this.videoPlayer.currentTime = 50;
  }

  applyPrism() {

    this.JavaServiceXMLPrism = this.SwiftServiceXMLPrism = this.JavaScriptServiceXMLPrism = Prism.highlight(this.JavaServiceXML, Prism.languages.java);
    this.JavaOnResultPrism = this.SwiftOnResultPrism = this.JavaScriptOnResultPrism = Prism.highlight(this.JavaOnResult, Prism.languages.java);
    this.JavaCommandPrism = this.JavaScriptCommandPrism = this.SwiftCommandPrism = Prism.highlight(this.JavaScriptCommand, Prism.languages.java);
    this.JavaGradlePrism = this.JavaScriptGradlePrism = this.SwiftGradlePrism = Prism.highlight(this.JavaScriptGradle, Prism.languages.java);
    this.JavaSourceCompatPrism = this.JavaScriptSourceCompatPrism = this.SwiftSourceCompatPrism = Prism.highlight(this.JavaSourceCompat, Prism.languages.java);
    this.JavaImplementationPrism = this.JavaScriptImplementationPrism = this.SwiftImplementationPrism = Prism.highlight(this.JavaImplementation, Prism.languages.java);
    this.JavaDependenciesPrism = this.JavaScriptDependenciesPrism = Prism.highlight(this.JavaDependencies, Prism.languages.java);
    this.SwiftDependenciesPrism = Prism.highlight(this.SwiftDependencies, Prism.languages.markup);
    this.JavaScriptiOSDependenciesPrism = Prism.highlight(this.JavaScriptiOSDependencies, Prism.languages.markup);
  }

  goBleExamplePage() {
    this.router.navigate(['/sgconnectedge/example-SGCashlessConnectEdge']);
  }

}
